import { memo } from 'react';
import { Container, Col, Row, } from 'react-bootstrap';
import { BzCard, BzChip, BzHeading } from '../../../../components';


const TrendingCard = ({ exploreFundsData, setShowDetailPage }) => {

    return (
        <Container fluid className='p-0'>
            <Row className='g-0 pb-3'>
                <Col className='d-flex'>
                    <div className='d-flex justify-content-center align-items-center'>
                        <BzHeading className='font-medium font-size6 color-text'>Trending now</BzHeading>
                        <div className='icon-16 icon-info icon-dark ms-2'>&nbsp;</div>
                    </div>
                    <div className='d-flex justify-content-center align-items-center ms-4'>
                        <div className='d-flex align-items-center cursor-pointer' onClick={() => { setShowDetailPage(true); }}>
                            <BzHeading className='font-medium font-size4 color-text'>View All</BzHeading>
                            <div className='icon-12 icon-forward-arrow icon-dark ms-2'>&nbsp;</div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row className='g-0'>
                <Col>
                    <div className='mutual-funds-trending-card-wrap'>
                        {exploreFundsData?.map((element, i) => (
                            <BzCard key={i} className='mutual-funds-trending-card'>
                                <Row className='g-0 mb-2'>
                                    <Col className='mutual-funds-trending-card-title'>
                                        <BzHeading className='font-medium font-size5 color-text text-wrap'>{element.fundName}</BzHeading>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-3'>
                                    <Col>
                                        <div className='chips-wrap flex-wrap'>
                                            {element?.category?.map((element, i) =>
                                                <BzChip key={i} className='chips primary-chip me-2'>{element}</BzChip>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                                <Row className='g-0'>
                                    <Col className='flex-column'>
                                        <div className='font-regular font-size2 color-subtext'>Min. Invesment</div>
                                        <div className='font-medium font-size4 color-text'>&#8377;{element.minAmount}</div>
                                    </Col>
                                    <Col className='flex-column'>
                                        <div className='font-regular font-size2 color-subtext'>CAGR</div>
                                        <Row className='g-0'>
                                            <Col md={3} className='d-flex'>
                                                <div className='font-medium font-size2 color-text color-positive'>{element.cagr}</div>
                                                <div className='font-regular font-size2 color-text ms-1'>(3Y)</div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </BzCard>
                        ))}
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default memo(TrendingCard);
